import { render, staticRenderFns } from "./BirthDate.vue?vue&type=template&id=1c689212&"
import script from "./BirthDate.vue?vue&type=script&lang=js&"
export * from "./BirthDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports